import { render, staticRenderFns } from "./FroalaEditor.vue?vue&type=template&id=593dbc3b&scoped=true&"
import script from "./FroalaEditor.vue?vue&type=script&lang=js&"
export * from "./FroalaEditor.vue?vue&type=script&lang=js&"
import style0 from "./FroalaEditor.vue?vue&type=style&index=0&id=593dbc3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593dbc3b",
  null
  
)

export default component.exports